export default __webpack_public_path__ + "static/media/h-nutrition-logo.d694ff2e.png";